<script lang="ts">
	import { goto } from '$app/navigation';
	import Button from '$lib/components/Button/Button.svelte';
	import FormDivider from '$lib/components/Divider/FormDivider.svelte';
	import SocialSignUpForm from '$lib/components/Form/SocialSignUpForm.svelte';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';

	const { t } = getTranslate();

	export let additionalClass = '';
</script>

<div class={classes(additionalClass, 'flex flex-col items-center justify-center overflow-hidden')}>
	<div class="w-full flex flex-col max-w-[400px]">
		<h1 class="mb-4 text-xl font-semibold w-full">{@html $t('signup.step0.headline')}</h1>
		<SocialSignUpForm
			additionalClass="max-w-[350px] md:max-w-full"
			additionalButtonClass="max-w-[350px] md:max-w-full"
			on:success
			on:emailSuccess
		/>
		<FormDivider additionalClass="max-w-[350px] md:max-w-full mt-8" />
		<Button
			on:click={() => goto('/auth/login')}
			data-test="__login-submit"
			additionalClass="max-w-[350px] md:max-w-full mt-4 w-full text-white bg-black"
			>{$t('login.button')}</Button
		>
	</div>
</div>
